<template>
  <div :class="isApp == true ? '' : 'content'">
    <Header></Header>
    <div class="main" v-show="isApp == true ? false : true">
      <!-- <div class="main_left">
        <div class="index-buygift">
          <img src="../assets/index/btn-buygift-top.gif" alt="" />
          <a class="btn-buygift buy" href="">
            <img v-show="isbuyIconEn" src="../assets/index/buy_en.png" alt="" />
            <img v-show="isbuyIconZh" src="../assets/index/buy_zh.png" alt="" />
          </a>
        </div>
        <div class="index-transfer">
          <img src="../assets/index/btn-transfer-top.gif" alt="" />
          <a class="btn-transfer" href="">
            <img
              v-show="isbuyIconEn"
              src="../assets/index/gift_en.png"
              alt=""
            />
            <img
              v-show="isbuyIconZh"
              src="../assets/index/gift_zh.png"
              alt=""
            />
          </a>
        </div>

        <div class="side-info-wrap">
          <div class="side-info-gradient">
            <div class="dw-motion">
              <img src="../assets/index/yao.gif" alt="" />
            </div>
           <div class="xiazai">
              <div class="xia_left">
                <div class="">
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_top">
                    <img
                      src="../assets/index/qrcode-ios.png"
                    />
                  </a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank"
                    ><div class="dianji">
                      {{ $t("index.xiaZai")
                      }}<i class="el-icon-caret-right"></i></div
                  ></a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_center">
                    <img src="../assets/index/ma.png" alt="" />
                  </a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_btm">
                    <img src="../assets/index/ma2.png" alt="" />
                  </a>
                </div>
              </div>
              <div class="xia_right subb">
                <div class="" @click="goDown">
                  <a class="xia_left_top">
                    <img
                      src="../assets/index/qrcode-akp.png"
                    />
                  </a>
                  <a>
                    <div class="dianji">
                      {{ $t("index.xiaZai")
                      }}<i class="el-icon-caret-right"></i>
                    </div>
                  </a>
                  <a class="xia_left_center"
                    ><img src="../assets/index/apk.png" alt=""
                  /></a>
                </div>
              </div>
            </div>

            <div class="fbBtn_wrap" style="padding:0.2rem">
              <a href="https://t.me/Tiger777com" target="_blank">
                  <img src="../assets/index/liaotian.png" style="width:9.375rem;height:3.125rem" alt="">
                </a>
            </div>
          </div>
        </div>
      </div> -->
      <MainLeft></MainLeft>
      <div class="main_content">
        <div class="navigation">
          {{ $t("teaching.home") }}>>{{ $t("leader.paihang") }}>>{{ showTitle }}
        </div>
        <div class="big_bod">
          <div class="paihang_title subb">
            <div
              :class="active == index ? 'paihang_sub' : 'paihang'"
              v-for="(item, index) in rankingList"
              :key="index"
              @click="changeTitle(item, index)"
            >
              {{ item.title }}
            </div>
          </div>
          <div class="small_bod">
            <div class="small_bod_small">
              <div v-show="isPaihang">
                <div class="select">
                  <el-select
                    v-model="value"
                    class=""
                    placeholder=""
                    popper-class="select"
                    :popper-append-to-body="true"
                    @change="changeSelect(value)"
                  >
                    <el-option
                      v-for="(item, index) in optionsList"
                      :key="index"
                      :label="item.lable"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="ranking_total">
                  <div class="ranking_msg">
                    <div class="ranking_msg_time">
                      {{ $t("leader.time") }} : {{ showTime }}
                    </div>
                    <div class="ranking_msg_msg">
                      {{ $t("leader.hall") }} : {{ showHall }}
                    </div>
                  </div>
                  <div class="ranking_msg_tips">
                    {{ $t("leader.tips") }}
                  </div>
                  <div>
                    <div class="ranking_item">
                      <div class="ranking_item_width_left">
                        {{ $t("leader.ranking") }}
                      </div>
                      <div class="ranking_item_width_center">
                        {{ $t("leader.userId") }}
                      </div>
                      <div class="ranking_item_width_right">
                        {{ $t("leader.integral") }}
                      </div>
                    </div>
                    <div
                      v-for="(item, index) in rankList"
                      :key="index"
                      class="ranking_item_item"
                    >
                      <div class="ranking_item_width_left">{{ item.ranking }}</div>
                      <div class="ranking_item_width_center">{{ item.userId }}</div>
                      <div class="ranking_item_width_right">{{ item.integral }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="isZhong">
                <div class="zhong" v-show="isNone">{{ $t("leader.none") }}</div>
                <div class="awardsList subb">
                  <div
                    v-for="(item, index) in awardsList"
                    :key="index"
                    :class="isAwards == index ? 'awardsTime_sub' : 'awardsTime'"
                    @click="chanegAwardsList(item, index)"
                  >
                    {{ item.lable }}
                  </div>
                </div>
                <div class="ctrlF">{{ $t("leader.ctrlF") }}</div>
                <div>
                  <div class="awardsList_list">
                    <div class="awardsList_list_top">
                      <div class="awardsList_top_list_left">{{ $t("leader.awards") }}</div>
                      <div class="awardsList_top_list_center">{{ $t("leader.gold") }}</div>
                      <div class="awardsList_top_list_right">{{ $t("leader.userId") }}</div>
                    </div>
                  </div>
                  <div
                    class="awardsList_list_top_sub"
                    v-for="(item, index) in awardsTotal"
                    :key="index"
                  >
                    <div class="awardsList_top_list_left awardsTotal_a">
                      {{ item.ranking }}
                    </div>
                    <div class="awardsList_top_list_center awardsTotal_b">
                     {{ item.integral }}
                    </div>
                    <div class="awardsList_top_list_right awardsTotal_c">
                      {{ item.userId }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="isapp" v-show="isApp == false ? false : true">
       <div class="isapp_paihang_title subb">
            <div
              :class="active == index ? 'isapp_paihang_sub' : 'isapp_paihang'"
              v-for="(item, index) in rankingList"
              :key="index"
              @click="changeTitle(item, index)"
            >
              {{ item.title }}
            </div>
          </div>
          <div class="isapp_small_bod">
            <div class="isapp_small_bod_small">
              <div v-show="isPaihang">
                <div class="select">
                  <el-select
                    v-model="value"
                    class=""
                    placeholder=""
                    popper-class="select"
                    :popper-append-to-body="true"
                    @change="changeSelect(value)"
                  >
                    <el-option
                      v-for="(item, index) in optionsList"
                      :key="index"
                      :label="item.lable"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="ranking_total">
                  <div class="ranking_msg">
                    <div class="isapp_ranking_msg_time">
                      {{ $t("leader.time") }} : {{ showTime }}
                    </div>
                    <div class="isapp_ranking_msg_msg">
                      {{ $t("leader.hall") }} : {{ showHall }}
                    </div>
                  </div>
                  <div class="isapp_ranking_msg_tips">
                    {{ $t("leader.tips") }}
                  </div>
                  <div class="minHeight">
                    <div class="isapp_ranking_item">
                      <div class="ranking_item_width_left">
                        {{ $t("leader.ranking") }}
                      </div>
                      <div class="ranking_item_width_center">
                        {{ $t("leader.userId") }}
                      </div>
                      <div class="ranking_item_width_right">
                        {{ $t("leader.integral") }}
                      </div>
                    </div>
                    <div
                      v-for="(item, index) in rankList"
                      :key="index"
                      class="ranking_item_item"
                    >
                      <div class="ranking_item_width_left">{{ item.ranking }}</div>
                      <div class="ranking_item_width_center">{{ item.userId }}</div>
                      <div class="ranking_item_width_right">{{ item.integral }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="isZhong">
                <div class="zhong" v-show="isNone">{{ $t("leader.none") }}</div>
                <div class="awardsList subb">
                  <div
                    v-for="(item, index) in awardsList"
                    :key="index"
                    :class="isAwards == index ? 'awardsTime_sub' : 'awardsTime'"
                    @click="chanegAwardsList(item, index)"
                  >
                    {{ item.lable }}
                  </div>
                </div>
                <div class="isapp_ctrlF">{{ $t("leader.ctrlF") }}</div>
                <div class="minHeight">
                  <div class="awardsList_list">
                    <div class="isapp_awardsList_list_top">
                      <div class="awardsList_top_list_left">{{ $t("leader.awards") }}</div>
                      <div class="awardsList_top_list_center">{{ $t("leader.gold") }}</div>
                      <div class="isapp_awardsList_top_list_right">{{ $t("leader.userId") }}</div>
                    </div>
                  </div>
                  <div
                    class="isapp_awardsList_list_top_sub"
                    v-for="(item, index) in awardsTotal"
                    :key="index"
                  >
                    <div class="awardsList_top_list_left awardsTotal_a">
                      {{ item.ranking }}
                    </div>
                    <div class="awardsList_top_list_center awardsTotal_b">
                      {{ item.integral }}
                    </div>
                    <div class="isapp_awardsList_top_list_right awardsTotal_c">
                      {{ item.userId }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </div>
    <Footer></Footer>
    <router-view />
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import "../assets/h5/leader.css"
export default {
  data() {
    return {
      lang:'4',
      isNumber:[],
      isAwards: 0,
      isNone: false,
      isbuyIconEn: true,
      isbuyIconZh: false,
      isPaihang: true,
      isZhong: false,
      active: 0,
      showTitle: "",
      label: "",
      value: "",
      rankingList: [
        // {
        //   title: "活动排行榜",
        //   options: [
        //     {
        //       label: "海王高手赛",
        //       time: "2022/02/28(00:00)~2022/02/03/01(00:00)",
        //       msg: "海王5-6-7",
        //       total: [
        //         {
        //           ranking: "1",
        //           userId: "WIN471113",
        //           integral: "4999",
        //         },
        //         {
        //           ranking: "2",
        //           userId: "WIN471113",
        //           integral: "4999",
        //         },
        //         {
        //           ranking: "3",
        //           userId: "WIN471113",
        //           integral: "4999",
        //         },
        //         {
        //           ranking: "4",
        //           userId: "WIN471113",
        //           integral: "4999",
        //         },
        //       ],
        //     },
        //     {
        //       label: "扑克之王赛",
        //       time: "2021/02/28(00:00)~2022/02/03/01(00:00)",
        //       msg: "扑克5-6-7",
        //       total: [
        //         {
        //           ranking: "1",
        //           userId: "WIN471113",
        //           integral: "4999",
        //         },
        //         {
        //           ranking: "2",
        //           userId: "WIN471113",
        //           integral: "4999",
        //         },
        //         {
        //           ranking: "3",
        //           userId: "WIN471113",
        //           integral: "4999",
        //         },
        //         {
        //           ranking: "4",
        //           userId: "WIN471113",
        //           integral: "4999",
        //         },
        //       ],
        //     },
        //     {
        //       label: "虎王高手赛",
        //     },
        //   ],
        // },
        // {
        //   title: "摸彩中奖名单",
        //   total: [
        //     {
        //       time: "03/02",
        //       list: [
        //         {
        //           jiangX: "头奖",
        //           price: "500,000",
        //           userId: "Takata76",
        //         },
        //         {
        //           jiangX: "二等奖",
        //           price: "500,000",
        //           userId: "Takata76",
        //         },
                
        //       ],
        //     },
        //     {
        //       time: "03/01",
        //       list: [
        //         {
        //           jiangX: "头奖",
        //           price: "700,000",
        //           userId: "Takata76",
        //         },
        //       ],
        //     },
        //     {
        //       time: "02/28",
        //       list: [
        //         {
        //           jiangX: "头奖",
        //           price: "800,000",
        //           userId: "Takata76",
        //         },
        //       ],
        //     },
        //   ],
        // },
      ],
      // rankingListSub: [
      //   {
      //     title: "活动排行榜",
      //     options: [
      //       {
      //         label: "海王高手赛",
      //         time: "2022/02/28(00:00)~2022/02/03/01(00:00)",
      //         msg: "海王5-6-7",
      //         total: [
      //           {
      //             ranking: "1",
      //             userId: "WIN471113",
      //             integral: "4999",
      //           },
      //           {
      //             ranking: "2",
      //             userId: "WIN471113",
      //             integral: "4999",
      //           },
      //           {
      //             ranking: "3",
      //             userId: "WIN471113",
      //             integral: "4999",
      //           },
      //           {
      //             ranking: "4",
      //             userId: "WIN471113",
      //             integral: "4999",
      //           },
      //         ],
      //       },
      //       {
      //         label: "扑克之王赛",
      //         time: "2021/02/28(00:00)~2022/02/03/01(00:00)",
      //         msg: "扑克5-6-7",
      //         total: [
      //           {
      //             ranking: "1",
      //             userId: "WIN471113",
      //             integral: "4999",
      //           },
      //           {
      //             ranking: "2",
      //             userId: "WIN471113",
      //             integral: "4999",
      //           },
      //           {
      //             ranking: "3",
      //             userId: "WIN471113",
      //             integral: "4999",
      //           },
      //           {
      //             ranking: "4",
      //             userId: "WIN471113",
      //             integral: "4999",
      //           },
      //         ],
      //       },
      //       {
      //         label: "虎王高手赛",
      //       },
      //     ],
      //   },
      //   {
      //     title: "摸彩中奖名单",
      //     total: [
      //       {
      //         time: "03/02",
      //         list: [
      //           {
      //             jiangX: "头奖",
      //             price: "500,000",
      //             userId: "Takata76",
      //           },
      //           {
      //             jiangX: "二等奖",
      //             price: "500,000",
      //             userId: "Takata76",
      //           },
                
      //         ],
      //       },
      //       {
      //         time: "03/01",
      //         list: [
      //           {
      //             jiangX: "头奖",
      //             price: "700,000",
      //             userId: "Takata76",
      //           },
      //         ],
      //       },
      //       {
      //         time: "02/28",
      //         list: [
      //           {
      //             jiangX: "头奖",
      //             price: "800,000",
      //             userId: "Takata76",
      //           },
      //         ],
      //       },
      //     ],
      //   },
      // ],
      optionsList: [],
      showTime: "",
      showHall: "",
      rankList: [],
      awardsList: [],
      awardsTotal: [],
    };
  },
  computed: {
    ...mapState({
      isApp(state) {
        return state.isApp;
      },
    }),
  },
  created() {
    this.changeIcon();

    // this.showOptions();
    this.getBannerList()
  },
  methods: {
    goDown(){
     this.$router.push('/Down')
    },
        getBannerList() {
      var _that = this
      let obj = {
        lang:_that.lang
      };
      this.$FucPost(this.$store.state.ip + "/getRankList", obj)
        .then(function (res) {
          // console.log(res);
          _that.rankingList=res

          let aa = _that.rankingList[0].option;
            _that.optionsList = aa;
      // console.log('_that.optionsList',_that.optionsList)
      _that.value = aa[0].lable;
      _that.rankList = aa[0].total;
      _that.showTime = aa[0].time;
      _that.showHall = aa[0].msg;
      // console.log("_that.rankingList", _that.rankingList);
      // _that.awardsTotal = _that.rankingList[1].option
      // console.log("_that.awardsTotal",_that.rankingList[1].option[0],total[0])
      
        })
        .catch((err) => {
          console.log(err);
        });
    },
    chanegNumber(){
      if(index==1){
        this.isNumber="color1"
      }
      else{
        this.isNumber="color2"
      }
    },
    changeIcon() {
      let lang = localStorage.getItem("lang");
      if (lang == "en") {
        this.isbuyIconEn = true;
        this.isbuyIconZh = false;
      }
      if (lang == "zh") {
        this.isbuyIconEn = false;
        this.isbuyIconZh = true;
      }
    },
    changeTitle(e, index) {
      this.showTitle = e.title;
      this.active = index;
      // console.log("e1", e);
      // console.log("index", index);
      if (index == 0) {
        this.isPaihang = true;
        this.isZhong = false;
      }
      if (index == 1) {
        this.isPaihang = false;
        this.isZhong = true;
        this.awardsList = e.option;
        this.awardsTotal = this.awardsList[0].total;
        // console.log("this.awardsList", this.awardsList);
      }
      // this.options = e.options;
    },
    changeSelect(e) {
      // console.log("e", e);
      this.value = e.lable;
      this.showTime = e.time;
      this.showHall = e.msg;
      this.rankList = e.total;
    },
    showList() {
      var langNum=localStorage.getItem("lang");
      console.log('langNum',langNum)
      if(langNum=='zh'){
        this.lang=3
      }
      if(langNum=='en'){
        this.lang=4
      }
      // this.showTime = this.options[0].time;
      // this.showHall = this.options[0].msg;
      // this.rankList = this.options[0].total;
    },

    //第一次进入页面暂时[0]的数据
    showOptions() {
      // let aa = this.rankingList[0].options;
      // this.value = aa[0].label;
      // this.optionsList = aa;
      // this.rankList = aa[0].total;
      // this.showTime = aa[0].time;
      // this.showHall = aa[0].msg;
      // console.log("this.rankingList", this.rankingList);
      // this.awardsTotal = this.rankingList[1].total[0].list
    },
    chanegAwardsList(e, index) {
      // console.log("chanegAwardsList", e);
      this.isAwards = index;
      this.awardsTotal = e.total;
      // console.log("this.awardsTotal", this.awardsTotal);
    },
  },
};
</script>
<style lang="less" scoped="">
// .content {
//   width: 100%;
//   background: #ad0000
//     url("https://www.jinjinjin777.com/static/images/bg-pc-head.jpg") center top
//     no-repeat;
//   background-size: 100% auto;
// }
.main_content {
  width: 75%;
  float: right;
}
.select {
  display: flex;
  align-content: flex-start;
}
/deep/.el-select {
  background-color: rgb(155, 131, 82);
  text-align: left;
  color: red;
}
.big_bod {
  width: 55.5rem;
  // height: 50rem;
  background-color: rgb(188, 152, 30);
  border: 0.125rem solid white;
  border-radius: 0.3125rem;
}
.paihang_sub {
  text-align: left;
  padding: 0.625rem;
  background-image: linear-gradient(#eade38 0%, #ccb127 50%, #bc981e 100%);
  color: white;
  font-size: 1.125rem;
}
.paihang {
  // border: 0.0625rem solid white;
  text-align: left;
  padding: 0.625rem;
  // background-image: linear-gradient(#eade38 0%, #ccb127 50%, #bc981e 100%);
  color: #3a1302;
  font-size: 1.125rem;
}
.small_bod {
  background-color: rgb(215, 206, 176);
  width: 96%;
  margin: 0 auto;
  padding: 0.3125rem;
  border: 0.125rem solid #3a1302a9;
  border-radius: 0.3125rem;
  margin-bottom: 0.625rem;
  margin-top: 0.625rem;
}
.small_bod_small {
  padding: 0.625rem 1.25rem;
}
.ranking_msg {
  color: #832e0a;
  float: left;
  text-align: left;
  font-weight: 600;
  margin: 0.625rem 0;
}
.ranking_total {
  display: flex;
  flex-direction: column;
}
.ranking_msg_msg {
  margin-top: 0.3125rem;
}
.ranking_msg_tips {
  float: left;
  margin: 0.3125rem;
  color: #81503b;
}
.ranking_item {
  display: flex;
  // justify-content: space-between;
  background-color: rgb(186, 138, 43);
  padding: 0.625rem 1.25rem;
  color: white;
}
.minHeight{
  min-height: 12.5rem;
}
.isapp_ranking_item {
  display: flex;
  // justify-content: space-between;
  background-color: rgb(157, 28, 24);
  padding: 0.625rem 1.25rem;
  color: white;
}
.ranking_item_item {
  display: flex;
  // justify-content: space-between;
  padding: 0.625rem 1.25rem;
  color: #7b4b00;
  background: linear-gradient(180deg, #f2f2f2, #b4b2b2);
}
.ranking_item_width_left{
  width: 20%;
  text-align: left;
}
.ranking_item_width_center{
  width: 40%;
  text-align: center;
}
.ranking_item_width_right{
  width: 40%;
  text-align: center;
}
.paihang_title {
  display: flex;
  flex-direction: row;
}
.zhong {
  line-height: 2.5rem;
  height: 2.5rem;
  background-image: linear-gradient(
    90deg,
    transparent 0%,
    #b96c06 50%,
    transparent 100%
  );
  color: #fff3ce;
  font-size: 1.25rem;
  margin: 0 auto;
  padding: 1.25rem auto;
  text-align: center;
  width: 70%;
}
.awardsList {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0.625rem 0;
}
.awardsTime {
  color: white;
  background: #ba9869;
  font-size: 0.875rem;
  height: 2.875rem;
  line-height: 2.875rem;
  margin: 0 0.375rem;
  width: 2.875rem;
  border-radius: 3.125rem;
  font-weight: 600;
}
.awardsTime_sub {
  color: white;
  background: #88220e;
  font-size: 0.875rem;
  height: 2.875rem;
  line-height: 2.875rem;
  margin: 0 0.375rem;
  width: 2.875rem;
  border-radius: 3.125rem;
  font-weight: 600;
}
.ctrlF {
  text-align: left;
  color: #755801;
    text-align: left;
    font-size: 0.9375rem;
    margin: 0.3125rem 0 0.625rem 0;
}
.awardsList_list_top_sub {
   display: flex;
  flex-direction: row;
   padding: 0.625rem 1.875rem;
   background-color: rgb(254, 252, 239);
   border-bottom: 0.0625rem solid rgb(215, 206, 176);
}
.awardsList_list_top {
  display: flex;
  flex-direction: row;
  padding: 0.625rem 1.875rem;
  background: #bc981e;
  color: white;
}
.awardsList_top_list_left {
  width: 20%;
  text-align: left;
}
.awardsList_top_list_center {
  width: 40%;
  text-align: center;
}
.awardsList_top_list_right {
  width: 40%;
  text-align: center;
}
.awardsTotal_a {
  color: #980707;
}
.awardsTotal_b {
  color: #9d570c;
}
.awardsTotal_c {
  color: #6d2701;
}
.xia_left_center img{
  width: 5.9375rem;
  height: 1.9375rem;
}
.xia_left_btm img{
  width: 5.9375rem;
  height: 1.9375rem;
}
.xiazaitu{
 width: 5.9375rem;
  height: 1.9375rem;
}
</style>
